import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";

const CerrarCajaModal = ({ show, onClose, onSave, showCreate, title, initDataApertura, initDataCierre }) => {
    const { handleSubmit: handleSubmitModal, register: registerModal, reset: resetModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    const [nombreCaja, setNombreCaja] = useState(CONFIGURACIONES.INIT.STRING);
    const [saldoSoles, setSaldoSoles] = useState(CONFIGURACIONES.INIT.STRING);
    const [saldoDolares, setSaldoDolares] = useState(CONFIGURACIONES.INIT.STRING);

    useEffect(() => {
        resetModal();
        if (initDataApertura !== CONFIGURACIONES.INIT.NULL && initDataApertura.cajaActiva !== CONFIGURACIONES.INIT.NULL) {
            setNombreCaja(initDataApertura.cajaActiva.nombre_caja);
        }

        if (initDataCierre !== CONFIGURACIONES.INIT.NULL) {
            setSaldoSoles(initDataCierre.monto_soles);
            setSaldoDolares(initDataCierre.monto_dolares);
        }
    }, [initDataApertura, initDataCierre]);


    const fnSave = (form) => {
        let data = {
            'saldoCierreSoles': initDataCierre.monto_soles,
            'saldoCierreDolares': initDataCierre.monto_dolares
        }
        onSave(data);
    };

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(fnSave)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="caja" className="control-label col-form-label">Caja <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="caja"
                                        id="caja"
                                        {...registerModal("caja", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE,
                                            value: nombreCaja
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.caja && errorsModal.caja.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="saldoSoles" className="control-label col-form-label">Saldo <small className="text-muted">(Soles)</small> <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="saldoSoles"
                                        id="saldoSoles"
                                        {...registerModal("saldoSoles", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            value: saldoSoles,
                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.saldoSoles && errorsModal.saldoSoles.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="saldoDolares" className="control-label col-form-label">Saldo <small className="text-muted">(Dólares)</small> <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="saldoDolares"
                                        id="saldoDolares"
                                        {...registerModal("saldoDolares", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            value: saldoDolares,
                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.saldoDolares && errorsModal.saldoDolares.message }</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={() => onClose(CONFIGURACIONES.INIT.FLAG_CLOSE)}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect">
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default CerrarCajaModal;
